import React from 'react'
import { observer } from 'mobx-react'
import { getMapValue, useEnvValue, useWillPipe } from '@morningtrain/react-helpers'
import { useModel, useOperations } from '@morningtrain/react-resources'
import useDepartmentId from 'support/hooks/use-department-id'
import { useRouter } from '@morningtrain/react-navigation'

function DetermineDeliveryDatesOnPipe (props) {
  const model = useModel()
  const [envData, setEnvData] = useEnvValue('globals.inventory.delivery_days', {})
  const operationRepository = useOperations()
  const router = useRouter()

  const [departmentId] = useDepartmentId()

  const operation = operationRepository.get('api', 'inventory.supplier', 'delivery_days')

  useWillPipe((payload) => {
    return new Promise((resolve, reject) => {
      console.log(model)
      const request = {
        department: departmentId,
        inventory_supplier: getMapValue(model, 'supplier_id', router.parameter('inventory_supplier')),
        inventory_order: getMapValue(model, 'id')
      }

      operation.execute(request)
        .then(data => {
          setEnvData(data.model)
          resolve(payload)
        })
        .catch(err => {
          reject(err)
        })
    })
  }, [model, departmentId, operation])

  return null
}

export default observer(DetermineDeliveryDatesOnPipe)
